import React, { useEffect } from 'react';
import { Table, Pagination, Menu, Button, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getUserMapping,
  getUserMappingSuccess,
  setUserMappingPerPage,
  setActiveUserMapping,
  openUserMappingDetails,
  closeUserMappingDetails,
} from 'state/userMapping/actions';
import UserMappingDetail from './UserMappingDetail';

const ListMapping = props => {
  const {
    dispatch,
    userMapping,
    userMappingPerPage,
    userMappingSearchKeyword,
    userMappingDetails,
    updatingUserMapping,
    deletingUserMapping,
    creatingUserMapping,
  } = props;
  const { data, paging } = userMapping;
  let totalPages = 1;
  if (paging) totalPages = Math.ceil(paging.total / paging.size);

  const handleOnPageChange = (_, val) => {
    const { activePage } = val;
    dispatch(
      getUserMapping({
        keyword: userMappingSearchKeyword,
        page: activePage,
        size: userMappingPerPage,
      })
    );
  };

  const handleOnUserPerPageClick = e => {
    dispatch(setUserMappingPerPage(e.target.value));
  };

  const handleUserMappingOnClick = index => {
    dispatch(setActiveUserMapping({ index, userMappingData: userMapping }));
    dispatch(openUserMappingDetails());
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(closeUserMappingDetails());
      dispatch(getUserMappingSuccess([]));
      if (
        userMappingSearchKeyword !== '' &&
        !updatingUserMapping &&
        !deletingUserMapping &&
        !creatingUserMapping
      ) {
        dispatch(
          getUserMapping({
            keyword: userMappingSearchKeyword,
            page: 1,
            size: userMappingPerPage,
          })
        );
      }
    }, 675);

    return () => clearTimeout(delayDebounceFn);
  }, [
    dispatch,
    userMappingPerPage,
    userMappingSearchKeyword,
    updatingUserMapping,
    deletingUserMapping,
    creatingUserMapping,
  ]);

  return (
    <>
      {paging ? (
        <>
          <Grid>
            <Grid.Column Column floated="right" textAlign="right" width={16}>
              Found: {paging.total} | View:
              <Button
                disabled={paging.size === 20}
                size="mini"
                color="blue"
                value={20}
                onClick={handleOnUserPerPageClick}
              >
                20
              </Button>
              <Button
                disabled={paging.size === 100}
                size="mini"
                color="blue"
                value={100}
                onClick={handleOnUserPerPageClick}
              >
                100
              </Button>
              <Button
                disabled={paging.size === paging.total}
                size="mini"
                color="blue"
                value={paging.total}
                onClick={handleOnUserPerPageClick}
              >
                All
              </Button>
            </Grid.Column>
          </Grid>
        </>
      ) : (
        <></>
      )}
      <Grid>
        <Grid.Column width={userMappingDetails ? 4 : 16}>
          <Table selectable singleline fixed>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Moka Email</Table.HeaderCell>
                {!userMappingDetails ? (
                  <>
                    <Table.HeaderCell>Moka Phone</Table.HeaderCell>
                    <Table.HeaderCell>Go Email</Table.HeaderCell>
                    <Table.HeaderCell>Go Phone</Table.HeaderCell>
                  </>
                ) : (
                  <></>
                )}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data ? (
                <>
                  {data.map((userMap, index) => (
                    <Table.Row
                      key={userMap.id}
                      onClick={() => handleUserMappingOnClick(index)}
                    >
                      {userMapping.activeIndex === index &&
                      userMappingDetails ? (
                        <Table.Cell key={userMap.email} active>
                          {userMap.email}
                        </Table.Cell>
                      ) : (
                        <Table.Cell key={userMap.email}>
                          {userMap.email}
                        </Table.Cell>
                      )}
                      {!userMappingDetails ? (
                        <>
                          <Table.Cell key={userMap.email}>
                            {userMap.phone}
                          </Table.Cell>
                          <Table.Cell
                            key={userMap.hermes ? userMap.hermes.email : null}
                          >
                            {userMap.hermes ? userMap.hermes.email : null}
                          </Table.Cell>
                          <Table.Cell
                            key={
                              userMap.hermes
                                ? userMap.hermes.phone_number
                                : null
                            }
                          >
                            {userMap.hermes
                              ? userMap.hermes.phone_number
                              : null}
                          </Table.Cell>
                        </>
                      ) : (
                        <></>
                      )}
                    </Table.Row>
                  ))}
                </>
              ) : (
                <></>
              )}
            </Table.Body>

            {paging && !userMappingDetails ? (
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="4">
                    <Menu floated="right">
                      <Pagination
                        defaultActivePage={paging.page}
                        totalPages={totalPages}
                        onPageChange={handleOnPageChange}
                        size="mini"
                      />
                    </Menu>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            ) : (
              <></>
            )}
          </Table>
        </Grid.Column>
        {userMappingDetails && userMapping.activeIndex !== -1 ? (
          <Grid.Column width={12}>
            <UserMappingDetail />
          </Grid.Column>
        ) : (
          <></>
        )}
      </Grid>
    </>
  );
};

const mapStateToProps = ({ userMapping }) => ({
  userMapping: userMapping.userMapping,
  userMappingSearchKeyword: userMapping.userMappingSearchKeyword,
  userMappingPerPage: userMapping.userMappingPerPage,
  gettingUserMapping: userMapping.gettingUserMapping,
  userMappingDetails: userMapping.userMappingDetails,
  updatingUserMapping: userMapping.updatingUserMapping,
  deletingUserMapping: userMapping.deletingUserMapping,
  creatingUserMapping: userMapping.creatingUserMapping,
});

ListMapping.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userMapping: PropTypes.object.isRequired,
  userMappingSearchKeyword: PropTypes.string.isRequired,
  userMappingPerPage: PropTypes.number.isRequired,
  userMappingDetails: PropTypes.bool.isRequired,
  updatingUserMapping: PropTypes.bool.isRequired,
  deletingUserMapping: PropTypes.bool.isRequired,
  creatingUserMapping: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ListMapping);
